import { render, staticRenderFns } from "./organizationbenshi.vue?vue&type=template&id=525e459c&"
import script from "./organizationbenshi.vue?vue&type=script&lang=js&"
export * from "./organizationbenshi.vue?vue&type=script&lang=js&"
import style0 from "./organizationbenshi.vue?vue&type=style&index=0&id=525e459c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports